var $ = require('jquery');
var ko = require('knockout');
var LearnArticlesViewModel = require('./learn-articles.vm.js');

$(function () {
    var target = $('.ws-learn-articles');

    target.each(function (index, item) {
        var $item = $(item);
        var vm = new LearnArticlesViewModel($item.data("page"),
            $item.data("page-size"),
            $item.data("categories"),
            $item.data("total"),
            $item.data("listing-page-id"));

        ko.applyBindings(vm, item);
    });
});